import React from 'react'
import SessionPageDetail from '../components/ItemDetail/SessionPageDetail'
import NavBar from '../components/Navbar/NavBar'
import Footer from '../components/Footer/Footer'

function Session()  {
return (
    <div>
        <NavBar/>
        <SessionPageDetail/>
        <Footer/>
    </div>
)
}

export default Session